import { useState, useEffect } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Loader2, Save, ExternalLink } from "lucide-react";
import { toast } from "sonner";

export default function RedirectsTab() {
  const [robots, setRobots] = useState(null);
  const [savingRobots, setSavingRobots] = useState(false);

  useEffect(() => {
    api.get("/admin/settings").then((r) => setRobots(r.data.robots_txt || "")).catch(() => setRobots(""));
  }, []);

  const saveRobots = async () => {
    setSavingRobots(true);
    try { await api.put("/admin/settings", { robots_txt: robots }); toast.success("robots.txt saved"); }
    catch { toast.error("Could not save robots.txt"); }
    finally { setSavingRobots(false); }
  };

  return (
    <div className="max-w-3xl space-y-8" data-testid="redirects-tab">
      <section>
        <h3 className="font-bold text-steel mb-1">Redirects</h3>
        <p className="text-xs text-muted-foreground" data-testid="redirects-moved-note">Redirect rules are now managed in <b>URL Repair &amp; Redirects</b> (next tab), with loop/chain protection, testing, audit log and restore.</p>
      </section>

      <section>
        <div className="flex items-center justify-between mb-1">
          <h3 className="font-bold text-steel">robots.txt</h3>
          <a href={`${process.env.REACT_APP_BACKEND_URL}/api/robots.txt`} target="_blank" rel="noreferrer" className="text-xs text-steel hover:text-accent inline-flex items-center gap-1">View live <ExternalLink size={12} /></a>
        </div>
        <p className="text-xs text-muted-foreground mb-3">Leave blank to use the safe default. A Sitemap line is appended automatically if missing. Avoid blocking important products or categories.</p>
        {robots === null ? <p className="text-xs text-muted-foreground"><Loader2 size={12} className="inline animate-spin mr-1" /> Loading…</p>
          : <Textarea rows={8} value={robots} onChange={(e) => setRobots(e.target.value)} className="font-mono text-xs" placeholder={"User-agent: *\nAllow: /\nDisallow: /admin"} data-testid="robots-editor" />}
        <Button onClick={saveRobots} disabled={savingRobots} className="mt-3 bg-accent text-steel hover:bg-amber-600 font-semibold" data-testid="robots-save">
          {savingRobots ? <Loader2 size={14} className="mr-1.5 animate-spin" /> : <Save size={14} className="mr-1.5" />} Save robots.txt
        </Button>
      </section>
    </div>
  );
}
